angular.module('app').controller('ManagePhotosCtrl', function($controller, $scope, $http, $mdDialog, appUtils, PhotoUtils, $mdToast, $rootScope) {
    "ngInject";

    var main = this;
    main.name = 'event_signup';
    main.selected = [];
    main.photoUtils = PhotoUtils;

    angular.extend(main, $controller('ItemCtrl', {'$scope': $scope, 'main': main}));

    main.remove = function(photo) {
        if(!confirm('Are you sure you want to delete ' + photo.filename + '?')) {
            return;
        }

        $http.delete('/api/v1/admin/event_signup/' + main.item.id + '/photos/' + photo.id).then(
            function(reponse) {
                appUtils.remove(photo, 'id', main.item.photos);
            }
        );
    };

    main.add = function() {
        PhotoUtils.uploadImage(
            '/api/v1/admin/event_signup/' + main.item.id + '/photos',
            function(response) {
                main.item.photos.push(response.data.photo);
            },
            {},
            'image/jpeg'
        );
    };

    main.copy = function(photo) {
        $mdDialog.show({
            'controller': 'BarcodeCtrl',
            'controllerAs': 'main',
            'clickOutsideToClose': true,
            'templateUrl': '/static/admin/templates/barcode.html?v=3',
            'multiple': true,
            'locals': {
                'photo': photo,
                'parent': main,
                'missing': false
            }
        }).then(
            function() {
                $http.put('/api/v1/admin/event_signup/' + photo.barcode + '/photos', {'photo_id': photo.id}).then(
                    function() {
                        var alert = $mdToast.simple().textContent("Copied photo");
                        $mdToast.show(alert);
                    }
                );
            }
        );
    };

    main.toggleYearbook = function(photo) {
        photo.yearbook_candidate = !photo.yearbook_candidate;
        if(photo.yearbook_selection && !photo.yearbook_candidate) {
            photo.yearbook_selection = false;
        }
        $http.put('/api/v1/admin/photo/' + photo.id, {'yearbook_candidate': photo.yearbook_candidate, 'yearbook_selection': photo.yearbook_selection}).then(function() {
            $rootScope.$broadcast('yearbook-updated');
        });
    };

    main.makeYearbookSelection = function(photo) {
        if(photo.yearbook_selection) {
            return true;
        } else {
            main.toggleYearbookSelection(photo);
        }
    }

    main.toggleYearbookSelection = function(photo) {
        photo.yearbook_selection = !photo.yearbook_selection;
        if(photo.yearbook_selection) {
            main.item.photos.forEach(function(checkPhoto) {
                if(photo != checkPhoto && checkPhoto.yearbook_selection) {
                    checkPhoto.yearbook_selection = false;
                    checkPhoto.yearbook_candidate = true;

                    $http.put('/api/v1/admin/photo/' + checkPhoto.id, {'yearbook_selection': false, 'yearbook_candidate': true});
                }
            });
        }
        $http.put('/api/v1/admin/photo/' + photo.id, {'yearbook_selection': photo.yearbook_selection}).then(function() {
            $rootScope.$broadcast('yearbook-updated');
        });
    };

    main.move = function(photo) {
        $mdDialog.show({
            'controller': 'BarcodeCtrl',
            'controllerAs': 'main',
            'clickOutsideToClose': true,
            'templateUrl': '/static/admin/templates/barcode.html?v=3',
            'multiple': true,
            'locals': {
                'photo': photo,
                'parent': main,
                'missing': false
            }
        }).then(
            function() {
                $http.delete('/api/v1/admin/event_signup/' + main.item.id + '/photos/' + photo.id).then(
                    function(response) {
                        $http.put('/api/v1/admin/event_signup/' + photo.barcode + '/photos', {'photo_id': photo.id}).then(
                            function(response) {
                                appUtils.remove(photo, 'id', main.item.photos);
                            }
                        );
                    }
                );
            }
        );
    };

    main.hide = function() {
        $mdDialog.hide();
    }

});
